/**
 * Created by quikr on 9/6/16.
 */
/**
 * Created by quikr on 8/16/16.
 */
import toastr from "toastr";
import ApiCli from "../../../helpers/ApiCli";
import {beginAjaxCall} from "../../actions/ajaxStatusActions";
import moment from "moment";


function parseDate(date) {
  return parseInt(date.toISOString().substr(8, 2));
}
function requestDate(date) {
  return date.toISOString().substr(0, 8) + fromDate.toString()
}

let AjaxCall = new ApiCli();

export function getAttendanceSuccess(attendance) {
  return {type: 'GET_ATTENDANCE_SUCCESS', attendance};
}
export function getRegularisationSuccess(regularisation) {
  return {type: 'GET_REGULARISATION_SUCCESS', regularisation};
}
export function getTeamAttendanceSuccess(attendanceTeam) {
  return {type: 'GET_TEAM_ATTENDANCE_SUCCESS', attendanceTeam};
}
export function getTeamRegularisationSuccess(teamRegularisation) {
  return {type: 'GET_TEAM_REGULARISATION_SUCCESS', teamRegularisation};
}
export function getTeamDetailsSuccess(teamDetails) {
  return {type: 'GET_TEAM_DETAILS_SUCCESS', teamDetails};
}

export function loadDefaultAttendance() {
  return function (dispatch) {
    let attendance = {
      attendance: {
        "empId": 0,
        "name": " ",
        "avgInTime": "00:00:00",
        "avgOutTime": "00:00:00 ",
        "avgWorkHours": "0:00:00",
        "attendance": [{}
        ]
      }
    };
    dispatch(getAttendanceSuccess(attendance));
  };
}

export function loadDefaultTeamAttendance() {
  return function (dispatch) {
    let attendanceTeam = {"attendanceTeam": {"attendanceTeam": []}};
    dispatch(getTeamAttendanceSuccess(attendanceTeam));
  };
}

export function getAttendance(search, pageNo = 0) {
  return function (dispatch) {
    dispatch(beginAjaxCall());

    let dateStart = search.startDate;
    let dateEnd = search.endDate;
    let endDate;
    let fromDate;
    if (pageNo != -1) {
      endDate = parseDate(dateEnd) + 1;
      fromDate = parseDate(dateStart) + 1;
    }
    else {
      pageNo = 0;
      endDate = parseDate(dateEnd);
      fromDate = parseDate(dateStart);
    }

    let request = {
      from: moment(search.startDate).format(),
      to: moment(search.endDate).format()
    };
    debugger;
    let call1 = AjaxCall.asyncAction('/attendance/_search?q=' + JSON.stringify(request) + '&page=' + pageNo + '&pageSize=15', 'get', null, null, dispatch);
    call1.then((response) => {

      const attendance = {attendance: response.data.data};
      dispatch(getAttendanceSuccess(attendance));
    }).catch((error) => {
    });
  };
}

export function getTeamAttendance(search) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let dateStart = search.startDate;
    let dateEnd = search.endDate;
    let endDate;
    let fromDate;
    if (search.pageNo != -1) {
      endDate = parseDate(dateEnd) + 1;
      fromDate = parseDate(dateStart) + 1;

    }
    else {
      search.pageNo = 0;
      endDate = parseDate(dateEnd);
      fromDate = parseDate(dateStart);

    }

    let request = {
      from: moment(search.startDate).format(),
      to: moment(search.endDate).format()
    };

    request.indirect = search.indirect;
    request.vertical = search.vertical;
    if (search.functionHead == null || search.functionHead == undefined)
      request.function = false;
    else
      request.function = search.functionHead;
    if (search.empId == -1)
      request.empId = null;
    else
      request.empId = search.empId;


    let call1 = AjaxCall.asyncAction('/attendance/team/_search?q=' + JSON.stringify(request) + '&page=' + search.pageNo + '&pageSize=25', 'get', null, null, dispatch);
    call1.then((response) => {
      const attendanceTeam = {"attendanceTeam": {"attendanceTeam": response.data.data}};

      dispatch(getTeamAttendanceSuccess(attendanceTeam));
    }).catch((error) => {
    });
  };
}
export function getTeamDetails(search, pageNo = 0) {
  return function (dispatch) {

    let dateStart = search.startDate;
    let dateEnd = search.endDate;
    let endDate;
    let fromDate;
    if (pageNo != -1) {
      endDate = parseDate(dateEnd) + 1;
      fromDate = parseDate(dateStart) + 1;

    }
    else {
      pageNo = 0;
      endDate = parseDate(dateEnd);
      fromDate = parseDate(dateStart);

    }

    let request = {
      from: moment(search.startDate).format(),
      to: moment(search.endDate).format(),
      name: search.name,
      empId: search.empId
    };

    dispatch(beginAjaxCall());
    let call1 = AjaxCall.asyncAction('/attendance/details/_search?q=' + JSON.stringify(request) + '&page=' + pageNo + '&pageSize=25', 'get', null, null, dispatch);
    call1.then((response) => {

      dispatch(getTeamDetailsSuccess(response.data.data));

    }).catch((error)=> {
      console.log(error);
    });
  }
}


export function getRegularisationAttendance(search, pageNo = 0) {
  return function (dispatch) {

    let dateStart = search.startDate;
    let dateEnd = search.endDate;
    let regStatus = search.regStatus;
    let endDate;
    let fromDate;
    if (pageNo != -1) {
      endDate = parseDate(dateEnd) + 1;
      fromDate = parseDate(dateStart) + 1;

    }
    else {
      pageNo = 0;
      endDate = parseDate(dateEnd);
      fromDate = parseDate(dateStart);

    }

    let request = {
      from: moment(search.startDate).format(),
      to: moment(search.endDate).format(),
        regStatus : regStatus
    };
    dispatch(beginAjaxCall());
    let call1 = AjaxCall.asyncAction('/attendance/regularization/_search?q=' + JSON.stringify(request) + '&page=' + pageNo + '&pageSize=2', 'get', null, null, dispatch);
    call1.then((response) => {
      const regularisation = {regularisation: {attendanceRegularization: response.data.data}};
      dispatch(getRegularisationSuccess(regularisation));
    }).catch((error) => {
      console.log(error);
    });
  };
}

export function getTeamRegularisation() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let call1 = AjaxCall.asyncAction('/attendance/team/regularization?q=1', 'get', null, null, dispatch);
    call1.then((response) => {

      const teamRegularisation = {teamRegularisation: response.data.data};
      dispatch(getTeamRegularisationSuccess(teamRegularisation));
      /*  axios.get('http://localhost:3333/public/teamreg.json').then((response)=>{
       const teamRegularisation ={teamRegularisation: response.data.data };
       dispatch(getTeamRegularisationSuccess(teamRegularisation));
       }).catch((error) =>
       {
       console.log(error);
       });*/
    }).catch((error) => {
      console.log(error);
    });

  };
}

export function applyForRegularisation(request, search) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let call1 = AjaxCall.asyncAction('/attendance/regularization', 'post', null, request, dispatch);

    call1.then((response) => {

      toastr.success("Successfully Applied")
      let dateStart = search.startDate;
      let dateEnd = search.endDate;

      let endDate = parseDate(dateEnd) + 1;
      let fromDate = parseDate(dateStart) + 1;

      let request = {
        from: moment(search.startDate).format(),
        to: moment(search.endDate).format()
      };


      let call2 = AjaxCall.asyncAction('/attendance/regularization/_search?q=' + JSON.stringify(request) + '&page=0&pageSize=2', 'get', null, null, dispatch);
      call2.then((response)=> {

        const regularisation = {regularisation: {attendanceRegularization: response.data.data}};
        dispatch(getRegularisationSuccess(regularisation));


      }).catch((error) => {
        console.log(error);
      });
    }).catch((error) => {
      console.log(error);
    });
  };
}

export function applyTeamRegularisation(request) {
  return function (dispatch) {
    dispatch(beginAjaxCall());

    let call1 = AjaxCall.asyncAction('/attendance/team/regularization', 'post', null, request, dispatch);
    toastr.success(request.data.processStatus + " success");
    call1.then((response) => {

      let call2 = AjaxCall.asyncAction('/attendance/team/regularization', 'get', null, null, dispatch);
      call2.then((response) => {

        const teamRegularisation = {teamRegularisation: response.data.data};
        dispatch(getTeamRegularisationSuccess(teamRegularisation));

      }).catch((error) => {
        console.log(error);
      });
    }).catch((error) => {
      console.log(error);
    });
  };
}








/** WEBPACK FOOTER **
 ** ./src/redux/actions/Attendance/attendanceActions.js
 **/